import myHealth from '@web/containers/MyHealth/localization'
import _ from 'lodash'
const localization = {
  en: {
    condition: '',
    dateIdentified: 'Date identified',
    status: 'Status'
  },
  es: {
    condition: '',
    dateIdentified: 'Fecha en que se identificó',
    status: 'Estado'
  },
  keyMapping: {
    condition: '',
    dateIdentified: 'UFD_Date_Identified_Text',
    status: 'UFD_Status_Text'
  }
}

export default _.merge(myHealth, localization)
